module.exports = __webpack_public_path__ + "img/img_web_1.bc140580.jpg";